import {
  Popover as ChakraPopover,
  PopoverContent,
  PopoverBody,
  PopoverAnchor,
  Box
} from "@chakra-ui/react";

export default function Dropdown({
  onClose,
  anchorEl,
  isOpen,
  onOpen,
  placement = "bottom-start",
  children,
  popoverProps,
  contentProps,
  anchorProps
}) {
  return (
    <ChakraPopover
      placement={placement}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      {...popoverProps}
    >
      <PopoverAnchor>
        <Box {...anchorProps}>{anchorEl}</Box>
      </PopoverAnchor>

      <PopoverContent {...contentProps}>
        <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
    </ChakraPopover>
  );
}
